import React, { useState } from 'react';
import { helpSections } from '../constants/helpContent';
import './Help.css';

function Help() {
  const [expandedSections, setExpandedSections] = useState(new Set(['getting-started']));
  const [showTourInfo, setShowTourInfo] = useState(true);

  const toggleSection = (sectionId) => {
    const newExpanded = new Set(expandedSections);
    if (newExpanded.has(sectionId)) {
      newExpanded.delete(sectionId);
    } else {
      newExpanded.add(sectionId);
    }
    setExpandedSections(newExpanded);
  };

  return (
    <div className="help-container">
      <div className="help-header">
        <h1>Help & Support</h1>
        <p>Everything you need to know about using ARFTCHC</p>
      </div>

      {/* Tour Info Banner */}
      {showTourInfo && (
        <div className="tour-banner">
          <div className="tour-content">
            <span className="tour-icon">🎯</span>
            <div className="tour-text">
              <h3>Interactive Tour Available!</h3>
              <p>A guided tour is available in the mobile app to help you learn the features step-by-step.</p>
            </div>
          </div>
          <button className="close-banner" onClick={() => setShowTourInfo(false)}>×</button>
        </div>
      )}

      {/* Quick Links */}
      <div className="quick-links">
        <h3>Quick Links</h3>
        <div className="link-grid">
          {helpSections.map((section) => (
            <button
              key={section.id}
              className="quick-link"
              onClick={() => {
                setExpandedSections(new Set([section.id]));
                document.getElementById(section.id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}
            >
              <span className="link-icon">{section.icon}</span>
              <span className="link-text">{section.title}</span>
            </button>
          ))}
        </div>
      </div>

      {/* FAQ Sections */}
      <div className="faq-sections">
        {helpSections.map((section) => {
          const isExpanded = expandedSections.has(section.id);
          
          return (
            <div key={section.id} className="faq-section" id={section.id}>
              <button
                className={`section-header ${isExpanded ? 'expanded' : ''}`}
                onClick={() => toggleSection(section.id)}
              >
                <div className="section-title">
                  <span className="section-icon">{section.icon}</span>
                  <h2>{section.title}</h2>
                </div>
                <span className="expand-icon">{isExpanded ? '▼' : '▶'}</span>
              </button>

              {isExpanded && (
                <div className="section-content">
                  {section.content.map((item, index) => (
                    <div key={index} className="faq-item">
                      <h4 className="question">Q: {item.question}</h4>
                      <p className="answer">{item.answer}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Contact Support */}
      <div className="support-card">
        <h3>Still Need Help?</h3>
        <p>
          If you have questions not covered here, please contact the administrator at support@support.mapryder.com 
          or reach out through the Chat feature.
        </p>
        <h3>Did you find a bug?</h3>
        <p>
          If you want to see a feature, or have an issue, please send an email to admin@support.mapryder.com
        </p>
        <h3>Want to contribute?</h3>
        <p>
          If you have a GitHub account and would like me to add you as a collaborator to this repository to post an issue or just review the code, Please email hobbs007@gmail.com. I will not be making this app public in its current form.
        </p>
      </div>
    </div>
  );
}

export default Help;
